import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type Credentials, type SessionState } from '../types';

const loginFulfilledCase: CaseReducer<
  SessionState,
  PayloadAction<Credentials>
> = (state, action) => {
  state.credentials = action.payload;
  state.status = 'logged';
  state.isLoading = false;
  state.hasError = false;
};

export { loginFulfilledCase };
